import { hashHistory } from 'react-router'
import { PATH_ZTB, PATH_ZTB_BUY } from './constant'
import mainStore from '@components/Main/store'
import {
  BOTH_SHOW__ZHI_GUANG_TONG_AND_ZHI_TUI_BAO,
  SHOW_ZHI_TUI_BAO
} from '@constant'

export const goZtb = () => {
  hashHistory.push(PATH_ZTB)
}

export const buyZhiTuiBao = () => {
  hashHistory.push(PATH_ZTB_BUY)
}

export const isShowZhiTuiBao = () => {
  const { cpm_type } = mainStore
  return (
    cpm_type == SHOW_ZHI_TUI_BAO ||
    cpm_type == BOTH_SHOW__ZHI_GUANG_TONG_AND_ZHI_TUI_BAO
  )
}
